import { Alert, AlertDescription, AlertIcon, AlertTitle, Divider, Flex, Spinner, Stack } from '@chakra-ui/react';
import MainCard from '../../../../components/MainCard/Index';
import { useGetRegistration } from '../../../../services/hooks/Registration/useGetRegistration';
import { useLocation } from 'react-router-dom';
import { TextM, TextXL, TextXS, TextXXS } from '../../../../components/Text/Index';
import { usePreliminaryResult } from '../../../../services/hooks/CandidateArea/useGetPreliminaryResult';
import ClassificationBox from '../../../../components/ClassificationComponent/ClassificationBox';
import { useContext } from 'react';
import { ContextAuth } from '../../../../contexts/Authentication';
import ResultLegacyMobilePage from './mobile/resultLegacy';

const PreliminaryResult: React.FC = () => {
  const { isMobile } = useContext(ContextAuth);
  const registration_id = useLocation().pathname.split('/')[3];
  const getRegistration = useGetRegistration(registration_id || '');
  const getResult = usePreliminaryResult(registration_id);

  const isLoading = getResult.isLoading || getRegistration.isLoading;

  const verifyResultPreliminary = !!(
    getResult.data?.classifications?.preliminary?.extensive_competition?.status ||
    getResult.data?.classifications?.preliminary?.black_or_brown?.status ||
    getResult.data?.classifications?.preliminary?.pcd?.status ||
    getResult.data?.classifications?.preliminary?.general?.status
  );

  const verifyResultFinal = !!(
    getResult.data?.classifications?.final?.extensive_competition?.status ||
    getResult.data?.classifications?.final?.black_or_brown?.status ||
    getResult.data?.classifications?.final?.pcd?.status ||
    getResult.data?.classifications?.final?.general?.status
  );

  if (isMobile) return <ResultLegacyMobilePage result={getResult.data} registration={getRegistration.data} />;

  const candidate = getRegistration.data?.candidate;

  return (
    <MainCard title="PROCESSO SELETIVO - " subtitle="RESULTADO">
      {(isLoading && (
        <Stack>
          <Spinner />
        </Stack>
      )) || (
        <Stack mx={[5, 5, 5, 20, 20, 20]}>
          <Flex
            justify={['flex-start', 'flex-start', 'flex-start', 'space-between', 'space-between']}
            flexDir={['column-reverse', 'column-reverse', 'column-reverse', 'row', 'row']}
          >
            <Stack marginTop={['60px', '60px', '60px', 0, 0]}>
              <Flex gap={2} flexDir={['column', 'column', 'row', 'row', 'row']}>
                <TextXS>
                  <strong>Nome completo: </strong>
                  {candidate?.user?.full_name || '--'}
                </TextXS>
                {candidate?.social_name && (
                  <TextXS>
                    <strong>Nome social: </strong>
                    {candidate?.social_name || '--'}
                  </TextXS>
                )}
                <TextXS>
                  <strong>{candidate?.is_foreign ? 'Passaporte' : 'CPF'}: </strong>
                  {candidate?.is_foreign ? candidate.passport_number : candidate?.cpf || '--'}
                </TextXS>
              </Flex>

              <TextXS>
                <strong>Número de Inscrição:</strong> {getRegistration.data?.registration_code || '--'}
              </TextXS>
              <TextXS>
                <strong>Processo seletivo: </strong>
                {getRegistration.data?.selective_process_vacancy?.selective_process?.name || '--'}
              </TextXS>
              <TextXS>
                <strong>
                  {getRegistration.data?.selective_process_vacancy?.cultural_house
                    ? getRegistration.data?.selective_process_vacancy.class_level
                      ? 'Turma: '
                      : 'Turma - Primeira opção: '
                    : 'Vaga: '}
                </strong>
                {getRegistration.data?.selective_process_vacancy?.name || '--'}
                <TextXS>{getRegistration.data?.selective_process_vacancy?.details || ''}</TextXS>
              </TextXS>
              {getRegistration.data?.second_vacancy?.name && (
                <TextXS>
                  <strong>Turma - Segunda opção: </strong>
                  {getRegistration.data?.second_vacancy?.name || '--'}
                  <TextXS>{getRegistration.data?.second_vacancy?.details || ''}</TextXS>
                </TextXS>
              )}
            </Stack>
          </Flex>

          <Stack>
            <Stack p={0} m={0}>
              <TextM textAlign="center" fontWeight="bold" textTransform="uppercase">
                Nota das provas
              </TextM>

              <Flex
                alignItems="center"
                flexWrap="wrap"
                justify={['center', 'center', 'center', 'center', 'center', 'center']}
                gap={3}
              >
                {getResult.data?.notes?.map((note) => (
                  <Stack
                    border="1px solid"
                    minWidth="250px"
                    maxW={['45%', '45%', '45%', 'fit-content']}
                    borderColor="primaryColor"
                    alignItems="center"
                    justifyContent="center"
                    px={2}
                    bg="linear-gradient(135deg, #002E5B, #004080)"
                    color="white"
                    borderRadius={4}
                    gap={0}
                    py={2}
                  >
                    <TextXS fontWeight="bold" px={2} py={1}>
                      {note.name.toUpperCase() || '--'}
                    </TextXS>

                    <Divider borderColor="white" />

                    <TextXL textAlign="center" fontWeight="bold">
                      {note?.value}
                      <TextXXS ml="2px">Pontos</TextXXS>
                    </TextXL>
                  </Stack>
                ))}

                {/* {getResult?.data?.invited_for_heteroidentification_test &&
                getResult?.data?.status_heteroidentification_result && (
                  <Stack
                    border="1px solid"
                    minWidth="250px"
                    maxW={['45%', '45%', '45%', 'fit-content']}
                    borderColor="primaryColor"
                    alignItems="center"
                    justifyContent="center"
                    px={2}
                    bg="linear-gradient(135deg, #002E5B, #004080)"
                    color="white"
                    borderRadius={4}
                    gap={0}
                    py={2}
                    minH="105px"
                  >
                    <TextXS fontWeight="bold" px={2} py={1}>
                      PROCESSO DE HETEROIDENTIFICAÇÃO
                    </TextXS>

                    <Divider borderColor="white" />

                    <Flex flex={1}>
                      <TextS textAlign="center" fontWeight="bold" mt={2}>
                        {getResult?.data?.status_heteroidentification_result?.toUpperCase() || '--'}
                      </TextS>
                    </Flex>
                  </Stack>
                )} */}
              </Flex>
            </Stack>

            <Divider pt={3} borderColor="secondaryColor" />

            {verifyResultPreliminary && (
              <Stack p={0} m={0}>
                <TextM textAlign="center" fontWeight="bold" textTransform="uppercase">
                  RESULTADO PRELIMINAR
                </TextM>

                <Flex
                  alignItems="center"
                  flexWrap="wrap"
                  justify={['center', 'center', 'center', 'center', 'center', 'center']}
                  gap={3}
                >
                  {getResult.data?.classifications?.preliminary?.extensive_competition?.status && (
                    <ClassificationBox
                      title={getResult.data.is_cultural_house ? '' : 'Ampla concorrência'}
                      classification={
                        getResult?.data?.classifications?.preliminary?.extensive_competition?.classification || ''
                      }
                      status={getResult?.data?.classifications?.preliminary?.extensive_competition?.status || ''}
                    />
                  )}

                  {getResult.data?.classifications?.preliminary?.black_or_brown?.status && (
                    <ClassificationBox
                      title={getResult.data.is_cultural_house ? '' : 'Pretos e pardos'}
                      classification={
                        getResult?.data?.classifications?.preliminary?.black_or_brown?.classification || ''
                      }
                      status={getResult?.data?.classifications?.preliminary?.black_or_brown.status || ''}
                    />
                  )}

                  {getResult.data?.classifications?.preliminary?.pcd?.status && (
                    <ClassificationBox
                      title={getResult.data.is_cultural_house ? '' : 'Pessoa com deficiência'}
                      classification={getResult?.data?.classifications?.preliminary?.pcd?.classification || ''}
                      status={getResult?.data?.classifications?.preliminary?.pcd?.status || ''}
                    />
                  )}

                  {getResult.data?.classifications?.preliminary?.general?.status && (
                    <ClassificationBox
                      title={getResult.data.is_cultural_house ? '' : 'Geral'}
                      classification={getResult?.data?.classifications?.preliminary?.general?.classification || ''}
                      status={getResult?.data?.classifications?.preliminary?.general?.status || ''}
                    />
                  )}
                </Flex>
              </Stack>
            )}

            {verifyResultFinal && (
              <>
                <Divider pt={3} borderColor="secondaryColor" />
                <Stack p={0} m={0}>
                  <TextM textAlign="center" fontWeight="bold" textTransform="uppercase">
                    RESULTADO FINAL
                  </TextM>

                  <Flex
                    alignItems="center"
                    flexWrap="wrap"
                    justify={['center', 'center', 'center', 'center', 'center', 'center']}
                    gap={3}
                    py={2}
                  >
                    {getResult.data?.classifications?.final?.extensive_competition?.status && (
                      <ClassificationBox
                        title={getResult.data.is_cultural_house ? '' : 'Ampla concorrência'}
                        classification={
                          getResult?.data?.classifications?.final?.extensive_competition?.classification || ''
                        }
                        status={getResult?.data?.classifications?.final?.extensive_competition?.status || ''}
                      />
                    )}

                    {getResult.data?.classifications?.final?.black_or_brown?.status && (
                      <ClassificationBox
                        title={getResult.data.is_cultural_house ? '' : 'Pretos e pardos'}
                        classification={getResult?.data?.classifications?.final?.black_or_brown?.classification || ''}
                        status={getResult?.data?.classifications?.final?.black_or_brown.status || ''}
                      />
                    )}

                    {getResult.data?.classifications?.final?.pcd?.status && (
                      <ClassificationBox
                        title={getResult.data.is_cultural_house ? '' : 'Pessoa com deficiência'}
                        classification={getResult?.data?.classifications?.final?.pcd?.classification || ''}
                        status={getResult?.data?.classifications?.final?.pcd?.status || ''}
                      />
                    )}

                    {getResult.data?.classifications?.final?.general?.status && (
                      <ClassificationBox
                        title={getResult.data.is_cultural_house ? '' : 'Geral'}
                        classification={getResult?.data?.classifications?.final?.general?.classification || ''}
                        status={getResult?.data?.classifications?.final?.general?.status || ''}
                      />
                    )}
                  </Flex>
                  {getResult?.data?.sub_judice && (
                    <Flex mb={3} w={'100%'} justify={'center'}>
                      <Flex w={['100%', '100%', '100%', '50%', '50%']}>
                        <Alert status="warning" variant="left-accent">
                          <AlertIcon />
                          <Stack>
                            <AlertTitle>Decisão judicial</AlertTitle>
                            <AlertDescription>
                              Informamos que o presente resultado foi modificado em decorrência de ordem judicial,
                              oriunda de ação movida por candidato, cuja decisão determinou a reclassificação.
                            </AlertDescription>
                          </Stack>
                        </Alert>
                      </Flex>
                    </Flex>
                  )}
                </Stack>
              </>
            )}
          </Stack>
        </Stack>
      )}
    </MainCard>
  );
};

export default PreliminaryResult;
